module.exports = __webpack_public_path__ + "static/media/REPORT-COUNT-4.d2e88c41.png";